import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { CartProvider } from "./hooks/useCart";
import { MemberProvider } from "./hooks/useMember";
import Navbar from "./components/feature/Navbar";
import Breadcrumb from "./components/feature/Breadcrumb";
import Footer from "./components/feature/Footer";

function LayoutWrapper() {
  const location = useLocation();
  // 根路径会立刻跳转登录/首页，不挂 Navbar，避免未登录时触发业务区请求
  const isBareLayout =
    location.pathname === "/login" || location.pathname === "/";

  if (isBareLayout) {
    return <AppRoutes />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-background-100">
      <Navbar />
      <Breadcrumb />
      <main className="flex-1 min-w-0 flex flex-col">
        <AppRoutes />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <MemberProvider>
          <LayoutWrapper />
        </MemberProvider>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;